import { CustomEventNames, EventTypes, logRBIEvent } from 'features/analytics';

import { appTrackingTransparency } from 'state/app-tracking-transparency-permissions';
import logger from 'utils/logger';
import { enableLocation, enablePush, openPushSetting } from 'utils/permissions';
import { promptReview } from 'utils/review/prompt-review';

export enum OsPrompts {
  push = 'push',
  location = 'location',
  review = 'review',
  att = 'att',
  pushSetting = 'pushSetting',
}

// checkForOSPrompts checks a URL for a `/OS/*`
// return true if /OS/ link
export const checkForOSPrompts = (url: string, callback?: () => void): boolean => {
  // If the link is /OS/* then prompt
  const parts = url.split('/');
  if (parts && parts.length === 3 && parts[1] === 'OS') {
    const routeTo = parts[2];

    switch (routeTo) {
      case OsPrompts.push:
        enablePush().then(() => {
          if (callback) {
            callback();
          }
        });
        return true;
      case OsPrompts.location:
        enableLocation()
          .catch(err => {
            logger.warn(`location: enableLocation error: ${err}`);
          })
          .finally(() => {
            if (callback) {
              callback();
            }
          });
        return true;
      case OsPrompts.review:
        promptReview().then(() => {
          if (callback) {
            callback();
          }
          logRBIEvent({
            name: CustomEventNames.APP_REVIEW_POP_UP,
            type: EventTypes.Other,
            attributes: {},
          });
        });
        return true;
      case OsPrompts.att:
        appTrackingTransparency()
          .then(() => {
            if (callback) {
              callback();
            }
          })
          .catch(() => {
            logger.warn(`Error in requesting user authorizaton for App Tracking Transparency`);
          });
        return true;
      case OsPrompts.pushSetting:
        openPushSetting();
        if (callback) {
          callback();
        }
        return true;
      default:
        logger.warn(`location: unknown OS/ link: ${url}`);
        return false;
    }
  }
  // No navigation is required so return undefined
  // return the URL
  return false;
};
